import { render, staticRenderFns } from "./PrizeListEditor.vue?vue&type=template&id=1bebc9de&"
import script from "./PrizeListEditor.vue?vue&type=script&lang=js&"
export * from "./PrizeListEditor.vue?vue&type=script&lang=js&"
import style0 from "./PrizeListEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports